import { render, staticRenderFns } from "./payroll_lesson_table.vue?vue&type=template&id=05b67172&"
import script from "./payroll_lesson_table.vue?vue&type=script&lang=js&"
export * from "./payroll_lesson_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports